module.exports = __webpack_public_path__ + "img/00000.114227a9.webp";